module.exports = __webpack_public_path__ + "static/media/fondo.4890613a.png";